'use client';

import { useEffect, Suspense } from 'react';
import { usePathname } from 'next/navigation';
import type { GtagConfig } from '@/types/analytics';

const GA_ID = process.env.NEXT_PUBLIC_GA_ID;

// Use regular function to access arguments object in ES5
function gtag(command: 'config' | 'event' | 'js', targetId: string | Date, config?: GtagConfig) {
  window.dataLayer.push(arguments);
}

// 提取需要useSearchParams的逻辑到子组件
function GoogleAnalyticsTracking() {
  const { useSearchParams } = require('next/navigation');
  const pathname = usePathname();
  const searchParams = useSearchParams();

  useEffect(() => {
    if (typeof window === 'undefined' || !GA_ID || !pathname || !window.gtag) {
      return;
    }

    try {
      window.gtag('config', GA_ID, {
        page_path: pathname + (searchParams?.toString() || ''),
      });
    } catch (error) {
      console.error('Error sending page view to Google Analytics:', error);
    }
  }, [pathname, searchParams]);

  return null;
}

// 加载状态组件
function GoogleAnalyticsFallback() {
  return null;
}

export default function GoogleAnalytics() {
  const pathname = usePathname();

  useEffect(() => {
    if (typeof window === 'undefined' || !GA_ID) {
      console.warn('Google Analytics ID not found or running on server');
      return;
    }

    try {
      const script = document.createElement('script');
      script.async = true;
      script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
      document.head.appendChild(script);

      window.dataLayer = window.dataLayer || [];
      window.gtag = gtag;
      
      window.gtag('js', new Date());
      window.gtag('config', GA_ID);
    } catch (error) {
      console.error('Error initializing Google Analytics:', error);
    }
  }, []);

  return (
    <Suspense fallback={<GoogleAnalyticsFallback />}>
      <GoogleAnalyticsTracking />
    </Suspense>
  );
}
